import { PlayerBase, ISeekingEvent, ISeekingOutOfDVREvent, ISeekedEvent } from '@24i/player-base';
import { useCallback } from 'react';
import { useEventListener } from '@24i/player-utils-react';
import { IPlayerEventProps } from '../Types';

const useEventsManager = (
    {
        onPlay,
        onPause,
        onSeeking,
        onSeekingOutOfDVR,
        onSeeked,
        onDurationChange,
        onAdBreakEnd,
        onAdBreakStart,
        onEnd,
        onBitrateChange,
    }: IPlayerEventProps,
    playerInstance: PlayerBase
) => {
    const onPlayHandler = useCallback(() => {
        if (onPlay) onPlay();
    }, [onPlay]);

    const onPauseHandler = useCallback(() => {
        if (onPause) onPause();
    }, [onPause]);

    const onSeekingHandler = useCallback(
        (event: ISeekingEvent) => {
            if (onSeeking) {
                onSeeking(event);
            }
        },
        [onSeeking]
    );

    const onSeekingOutOfDVRHandler = useCallback(
        (event: ISeekingOutOfDVREvent) => {
            if (onSeekingOutOfDVR) onSeekingOutOfDVR(event);
        },
        [onSeekingOutOfDVR]
    );

    const onSeekedHandler = useCallback(
        (event: ISeekedEvent) => {
            if (onSeeked) {
                onSeeked(event);
            }
        },
        [onSeeked]
    );

    const onDurationChangeHandler = useCallback(() => {
        if (onDurationChange) onDurationChange();
    }, [onDurationChange]);

    const onAdBreakEndedHandler = useCallback(() => {
        if (onAdBreakEnd) onAdBreakEnd();
    }, [onAdBreakEnd]);

    const onAdBreakStartedHandler = useCallback(
        (adBreak) => {
            if (onAdBreakStart) onAdBreakStart(adBreak);
        },
        [onAdBreakStart]
    );

    const onEndHandler = useCallback(() => {
        if (onEnd) onEnd();
    }, [onEnd]);

    const onBitrateChangeHandler = useCallback(
        (event) => {
            if (onBitrateChange) onBitrateChange(event);
        },
        [onBitrateChange]
    );

    useEventListener('play', onPlayHandler, playerInstance);
    useEventListener('pause', onPauseHandler, playerInstance);
    useEventListener('seeking', onSeekingHandler, playerInstance);
    useEventListener('seekingoutofdvr', onSeekingOutOfDVRHandler, playerInstance);
    useEventListener('seeked', onSeekedHandler, playerInstance);
    useEventListener('durationchange', onDurationChangeHandler, playerInstance);
    useEventListener('adbreakstarted', onAdBreakStartedHandler, playerInstance);
    useEventListener('adbreakended', onAdBreakEndedHandler, playerInstance);
    useEventListener('ended', onEndHandler, playerInstance);
    useEventListener('bitratechange', onBitrateChangeHandler, playerInstance);
};

export { useEventsManager };
